import React, { useState } from "react";
import AdminLayout from "./AdminLayout";
import DashboardPage from "./DashboardPage";
import ListingsPage from "./ListingsPage";
import ProfilePage from "./ProfilePage";
import AddListingPage from "./AddListingPage";

const REAdminPage1 = () => {
  // State management
  const [activeTab, setActiveTab] = useState('dashboard');
  const [showAddListingPage, setShowAddListingPage] = useState(false);
  const [editingListing, setEditingListing] = useState(null);
  
  // Agent profile state
  const [agentProfile, setAgentProfile] = useState({
    name: '',
    company: '',
    password: '',
    type: 'individual',
    contactInfo: {
      phone: '',
      email: '',
      address: ''
    }
  });

  // Mock data matching your structure
  const [listings, setListings] = useState([
    {
      Price: '6000000 yen',
      Room_Type: '1K',
      Year_of_Construction: '1972',
      Empty_or_Not: 'Rental',
      No_of_Floors: 2,
      Contact_Info: 'Tel: 042-596-0805 Tel: 042-519-9556',
      Area_of_House: '23 m',
      Area_of_Land: '23.0 m2',
      Address: 'Hinohara, Nishitama District, Tokyo',
      property_id: '04-06-HINOHARA-04',
      Link_to_Website: 'https://www.vill.hinohara.tokyo.jp/cmsfiles/contents/0000000/581/mitsugou34.pdf',
      Images: [
        'https://app.akiya2.com/public/7/Hinohara/4/images/image6.png',
        'https://app.akiya2.com/public/7/Hinohara/4/images/image7.png',
        'https://app.akiya2.com/public/7/Hinohara/4/images/image8.png',
        'https://app.akiya2.com/public/7/Hinohara/4/images/image9.png',
        'https://app.akiya2.com/public/7/Hinohara/4/images/image10.png'
      ],
      Coordinates: [35.7268216, 139.1488603],
      featured: true,
      status: 'active'
    },
    {
      Price: '8200000 yen',
      Room_Type: '3LDK',
      Year_of_Construction: '1985',
      Empty_or_Not: 'Sale',
      No_of_Floors: 2,
      Contact_Info: 'Tel: 075-123-4567',
      Area_of_House: '120 m',
      Area_of_Land: '150.0 m2',
      Address: 'Gion, Kyoto',
      property_id: 'KY-02-GION-15',
      Link_to_Website: '',
      Images: [
        'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=400',
        'https://images.unsplash.com/photo-1502672023488-70e25813eb80?w=400'
      ],
      Coordinates: [35.0028, 135.7681],
      featured: false,
      status: 'active'
    }
  ]);

  // Functions for managing listings
  const handleAddListing = (newListingData) => {
    setListings([...listings, { ...newListingData, status: 'active' }]);
    setShowAddListingPage(false);
  };

  const handleEditListing = (listing) => {
    setEditingListing(listing);
    setShowAddListingPage(true);
  };

  const handleUpdateListing = (updatedListing) => {
    setListings(listings.map(listing => 
      listing.property_id === updatedListing.property_id ? updatedListing : listing
    ));
    setShowAddListingPage(false);
    setEditingListing(null);
  };

  const handleFlagListing = (property_id) => {
    setListings(listings.map(listing => 
      listing.property_id === property_id 
        ? { ...listing, status: listing.status === 'flagged' ? 'active' : 'flagged' }
        : listing
    ));
  };

  const toggleFeatured = (property_id) => {
    setListings(listings.map(listing => 
      listing.property_id === property_id 
        ? { ...listing, featured: !listing.featured }
        : listing
    ));
  };

  const handleCloseListing = () => {
    setShowAddListingPage(false);
    setEditingListing(null);
  };

  const handleShowAddListing = () => {
    setEditingListing(null);
    setShowAddListingPage(true);
  };

  // If showing add/edit listing page, render only that
  if (showAddListingPage) {
    return (
      <AddListingPage 
        onSave={editingListing ? handleUpdateListing : handleAddListing}
        onCancel={handleCloseListing}
        editListing={editingListing}
      />
    );
  }

  // Render content based on active tab
  const renderActiveTab = () => {
    switch(activeTab) {
      case 'dashboard':
        return (
          <DashboardPage 
            listings={listings}
            setActiveTab={setActiveTab}
            setShowAddListingModal={handleShowAddListing}
          />
        );
      case 'listings':
        return (
          <ListingsPage 
            listings={listings}
            setShowAddListingModal={handleShowAddListing}
            handleEditListing={handleEditListing}
            handleFlagListing={handleFlagListing}
            toggleFeatured={toggleFeatured}
          />
        );
      case 'profile':
        return (
          <ProfilePage 
            agentProfile={agentProfile}
            setAgentProfile={setAgentProfile}
          />
        );
      default:
        return null;
    }
  };

  return (
    <AdminLayout activeTab={activeTab} setActiveTab={setActiveTab}>
      {renderActiveTab()}
    </AdminLayout>
  );
};

export default REAdminPage1;